export enum OrigemPedidoExportacaoEnum {
  CadastrosProdutos = 1,
  CadastrosPessoas = 2,
  FinancasContasPagar = 3,
  FinancasContasReceber = 4,
  ConfiguracoesFinancas = 5,
  SuprimentosControleEstoque = 6,
  NotasFiscaisPainelContador = 7,
  NotasFiscaisPainelNotasRecebidas = 8,
  VendasProcessoVenda = 9,
  SuprimentosNotasFiscaisEntrada = 10,
  VendasNotasFiscais = 11,
}
